export default "__VITE_ASSET__DON0ddyY__"